import React from "react";
import { Link } from "wouter";

interface Service {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  slug: string;
}

const services: Service[] = [
  {
    id: 1,
    name: "Phone Repair",
    description: "Screen replacement, battery replacement, charging port repair, camera repair, and more.",
    imageUrl: "https://images.unsplash.com/photo-1546054454-aa26e2b734c7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "phone-repair"
  },
  {
    id: 2,
    name: "Computer Repair",
    description: "Hardware upgrades, virus removal, data recovery, screen replacement, keyboard repair.",
    imageUrl: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "computer-repair"
  },
  {
    id: 3,
    name: "Tablet Repair",
    description: "Screen replacement, battery replacement, charging port repair, and software issues.",
    imageUrl: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "tablet-repair"
  },
  {
    id: 4,
    name: "Game Console Repair",
    description: "HDMI port repair, disc drive replacement, overheating issues, controller repair.",
    imageUrl: "https://images.unsplash.com/photo-1486572788966-cfd3df1f5b42?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "game-console-repair"
  }
];

const Services = () => {
  return (
    <section id="services" className="py-16 bg-neutral">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Our Repair Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We fix all major brands and models of smartphones, computers, tablets, and game consoles.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="bg-white rounded-lg shadow-md overflow-hidden service-card transition-all duration-300"
            >
              <img 
                src={service.imageUrl} 
                alt={service.name} 
                className="w-full h-48 object-cover" 
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{service.name}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <Link 
                  href={`/services/${service.slug}`} 
                  className="text-primary font-medium hover:text-[#FF6633] transition-colors flex items-center"
                >
                  View {service.name} Services
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            href="/services" 
            className="inline-block bg-primary text-white px-6 py-3 rounded-md font-medium hover:bg-opacity-90 transition-all"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
